<template>
    <div class="publication__filters content-width">

        <div class="d-flex">

            <div class="publication__section-inner d-flex">

                <div class="publication__section-item">
                    <div class="publication__section-title">{{$store.getters.t('personal_filters_is_donor')}}</div>
                    <div class="publication__section-list d-flex">
                        <div class="publication__section-list-item" v-for="item in filtersServer.default_temp">
                            <label class="d-flex">
                                <input type="radio" v-model="$v.is_donor.$model" :value="item.value">
                                <span class="circle"></span>
                                {{item.name}}
                            </label>
                        </div>
                    </div>
                    <div class="text-danger" v-if="$v.is_donor.$error" >{{$store.getters.t('common_invalid_value')}}</div>

                </div>

                <div class="publication__section-item">
                    <div class="publication__section-title">{{$store.getters.t('donors_weight')}}</div>
                    <div class="publication__section-list d-flex">
                        <div class="publication__section-list-item" v-for="(value, key) in filtersServer.dictionaries.weight">
                            <label class="d-flex">
                                <input type="radio" v-model="$v.weight.$model" :value="key">
                                <span class="circle"></span>
                                {{value}}
<!--                                {{$store.getters.t(
                                    key === 'up_to_3' ? 'donors_weight_up_to_3' :
                                    (key === '3_6' ? 'donors_weight_3_6' :
                                    (key === '6_10' ? 'donors_weight_6_10' :
                                    (key === '10_15' ? 'donors_weight_10_15' :
                                    (key === '15_25' ? 'donors_weight_15_25' :
                                    (key === '25_35' ? 'donors_weight_25_35' :
                                    (key === '35_plus' ? 'donors_weight_35_plus' : 'donors_weight_not_specified')))))))
                                }}-->
                            </label>
                        </div>
                    </div>
                    <div class="text-danger" v-if="$v.weight.$error">{{$store.getters.t('personal_filters_enter_weight')}}</div>
                </div>
            </div>

        </div>

        <div class="publication__filters-row">

            <div class="publication__filters-title">
                {{$store.getters.t('personal_filters_social_attributes')}}
            </div>

            <div class="publication__social d-flex">

                <div class="publication__social-item">
                    <div class="publication__social-icon">
                        <star :target="{name: 'to_children', value: to_children}" @handleSocial="handleSocial"/>
                        <span v-if="parseInt(to_children)" >{{`${to_children}.0`}}</span>
                    </div>
                    <div class="publication__social-name">
                        {{$store.getters.t('pet_info_to_children')}}
                    </div>

                    <div class="text-danger" v-if="$v.to_children.$error">{{$store.getters.t('common_invalid_value')}}</div>

                </div>

                <div class="publication__social-item">
                    <div class="publication__social-icon">
                        <star :target="{name: 'to_cats', value: to_cats}" @handleSocial="handleSocial"/>
                        <span v-if="parseInt(to_cats)" >{{`${to_cats}.0`}}</span>
                    </div>
                    <div class="publication__social-name">
                        {{$store.getters.t('pet_info_to_cats')}}
                    </div>

                </div>

                <div class="publication__social-item">
                    <div class="publication__social-icon">
                        <star :target="{name: 'to_dogs', value: to_dogs}" @handleSocial="handleSocial"/>
                        <span v-if="parseInt(to_dogs)" >{{`${to_dogs}.0`}}</span>
                    </div>
                    <div class="publication__social-name">
                        {{$store.getters.t('pet_info_to_dogs')}}
                    </div>

                </div>

                <div class="publication__social-item">
                    <div class="publication__social-icon">
                        <star :target="{name: 'enrichment', value: enrichment}" @handleSocial="handleSocial"/>
                        <span v-if="parseInt(enrichment)" >{{`${enrichment}.0`}}</span>
                    </div>
                    <div class="publication__social-name">
                        {{$store.getters.t('pet_info_home_behavior')}}
                    </div>

                </div>

                <div class="publication__social-item">
                    <div class="publication__social-icon">
                        <star :target="{name: 'human_sociability', value: human_sociability}" @handleSocial="handleSocial"/>
                        <span v-if="parseInt(human_sociability)" >{{`${human_sociability}.0`}}</span>
                    </div>
                    <div class="publication__social-name">
                        {{$store.getters.t('pet_info_socialization')}}
                    </div>

                </div>

            </div>

        </div>
    </div>
</template>

<script>


import { required, requiredIf} from 'vuelidate/lib/validators';

const initialData = {
    default_temp:   [ { value: 1, name: 'Yes' }, { value: 0, name: 'No' } ],
}

import Star from '../PublicationSocialStar';
import StateMixin from "../mixins/StateMixin";

export default {
    name: "PersonalFilters",
    props: ['server'],
    components: { Star },
    mixins: [StateMixin],
    computed: {

        filtersServer(){
            return {
                default_temp: [
                    { value: 1, name: this.$store.getters.t('volunteer_backend_settings_component_yes') },
                    { value: 0, name: this.$store.getters.t('volunteer_backend_settings_component_no') }
                ],
                dictionaries: this.server.dictionaries
            }
        },

        weight: {
            get() { return this.GET_BY_KEY('weight') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'weight', data: val})
            }
        },

        is_donor: {
            get() { return this.GET_BY_KEY('is_donor') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'is_donor', data: val})
            }
        },

        to_children: {
            get() { return this.GET_BY_KEY('to_children') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'to_children', data: val })
            }
        },

        to_dogs: {
            get() { return this.GET_BY_KEY('to_dogs') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'to_dogs', data: val || 'null'})
            }
        },

        to_cats: {
            get() { return this.GET_BY_KEY('to_cats') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'to_cats', data: val || 'null'})
            }
        },

        human_sociability: {
            get() { return this.GET_BY_KEY('human_sociability') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'human_sociability', data: val || 'null'})
            }
        },

        enrichment: {
            get() { return this.GET_BY_KEY('enrichment') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'enrichment', data: val || 'null'})
            }
        },



    },

    methods: {

        handleSocial({ target, rate }){
            this[target] = rate;
        },

        isValid(){
            this.$v.$touch();

            if( this.$v.$invalid ){
                this.$emit('parent-update', false );
                return false
            }

            this.$emit('parent-update', true )
            return true
        }
    },

    validations: {
        is_donor:    { required },
        to_children: { required },
        weight:      { required },
    }


}
</script>

<style scoped>

</style>
